import { IconType, GenIcon } from "react-icons/lib/esm/iconBase";

export const GeoZoneIcon: IconType = GenIcon({
  tag: "svg",
  attr: { viewBox: "0 0 512 512" },
  child: [
    {
      tag: "path",
      attr: {
        fillRule: "evenodd",
        d: "M466.001 109.495C469.134 113.622 467.679 119.861 467.485 125.145C467.317 129.701 431.211 394.757 430.639 399.851C430.066 404.946 428.504 407.85 425.723 411.001C422.942 414.153 419.137 416.411 412.501 417.65C405.864 418.89 194.574 466.849 189.803 467.844C185.033 468.839 179.451 470.181 174.615 466.225C170.65 462.982 170.495 460.008 169.436 455.476C168.378 450.944 136.063 324.895 136.063 324.895C136.063 324.895 47.0645 279.421 43.3263 277.651C39.5882 275.88 33.9033 273.458 31.3811 268.024C28.9793 262.849 30.1984 257.347 31.3807 253.415C32.5631 249.483 87.2801 71.7495 88.3788 67.9938C89.4775 64.2382 91.0535 60.8794 94.895 58.6117C99.5749 55.849 103.511 57.5332 108.811 58.6118C114.111 59.6903 281.668 106.968 281.668 106.968C281.668 106.968 444.961 104.958 452.27 104.901C459.579 104.844 462.869 105.367 466.001 109.495ZM98.8229 235.541L131.332 125.145L271.003 164.888L408.412 162.712L379.672 367.223L214.849 404.278L183.807 280.315L98.8229 235.541Z",
      },
      child: [],
    },
    {
      tag: "path",
      attr: {
        strokeWidth: "12",
        strokeLinecap: "round",
        d: "M162.076 156.013L131.82 198.372M217.546 171.627L162.076 247.268M271.897 191.349L210.692 274.911M340.89 186.755L227.818 339.553M374.034 233.144L271.897 367.877M361.061 324.123L340.89 351.353",
      },
      child: [],
    },
  ],
});
